<template>
  <div class="content">
   <div v-if="projectname.length >0">
    <van-grid
      v-if="$store.state.position != '渠道服务商'"
      :border="true"
      :column-num="3"
      :gutter="10"
    >
      <template v-for="(item, index) in menulist1">
        <van-grid-item
          :to="item.url"
          :key="index"
          :icon="item.Image"
          :text="item.title"
          square
          :icon-size="56"
          v-if="CheckRole(item)"
        >
        </van-grid-item>
      </template>
    </van-grid>
    <van-grid :border="true" :column-num="3" :gutter="10" v-else>
      <van-grid-item
        v-for="(item, index) in menulist2"
        :to="item.url"
        :key="index"
        :icon="item.Image"
        :text="item.title"
        square
        :icon-size="56"
      >
      </van-grid-item>
    </van-grid>
   </div>
   <div v-else class="error">
     请在个人中心选择当前工作项目!
   </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "cell",
  data() {
    return {
      projectname:"",
      position: "",
      usermenu: [],
      menulist1: [
        {
          Image: require("@/assets/tools/客户登记.png"),
          title: "客户登记",
          url: "/crmregister/new",
        },
        {
          Image: require("@/assets/tools/客户录入.png"),
          title: "客户录入",
          url: "/crmcreate/new",
        },
        {
          Image: require("@/assets/img/register.png"),
          title: "单客户确认",
          url: "/visit/single",
          role: "客户确认",
        },
        {
          Image: require("@/assets/img/register.png"),
          title: "组客户确认",
          url: "/visit/group",
          role: "客户确认",
        },
        {
          Image: require("@/assets/tools/问卷调查录入.png"),
          title: "调查问卷录入",
          url: "/questionnaire/new",
        },

        {
          Image: require("@/assets/tools/客户信息补全.png"),
          title: "客户信息完善",
          url: "/customerinfo",
        },
        
        {
          Image: require("@/assets/tools/待回访.png"),
          title: "待回访",
          url: "/crmulist",
        },
        //  {
        //   Image: require("@/assets/img/rengou.png"),
        //   title: "认购接待",
        //   url: "/rengou",
        // },
        {
          Image: require("@/assets/tools/已回访.png"),
          title: "已回访",
          url: "/crmlog",
        },
         {
          Image: require("@/assets/tools/公共池.png"),
          title: "公共池",
          url: "/crmpublic",
        },
        // {
        //   Image: require("@/assets/img/callbacknone.png"),
        //   title: "待回访",
        //   url: "/crmlog",
        // },
        // {
        //   Image: require("@/assets/img/sum.png"),
        //   title: "业绩分析",
        //   url: "/crmlog",
        // },
      ],
      menulist2: [
        {
          Image: require("@/assets/img/register.png"),
          title: "客户报备",
          url: "/crmregister/new",
        },
        {
          Image: require("@/assets/img/callbacklog.png"),
          title: "客户列表",
          url: "/crmulist",
        },
      ],
    };
  },
  created() {
    this.$nextTick(() => {
      // console.log("sdfsdffff",this.projectname)
      //if(localStorage.getItem("projectname") != null)
       this.projectname = "新基业当代阅ΜΟΜΛ" //localStorage.getItem("projectname");
    

      if (this.$store.state.position == "渠道服务商") {
        this.usermenu = this.menulist2;
      } else {
        this.usermenu = this.menulist1;
      }
    });
  },
  computed: {},
  methods: {
    CheckRole(item) {
      var roles=this.$store.state.roles
      if (item.role != undefined) {
        for(var i in roles){
          if(roles[i] == item.role){
            return true
          }
        }
        return false
        
        
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px;
}
.img {
  width: 56px;
}

.grid {
  margin: 10px;
  background-color: #fff;
  text-align: center;
  font-size: 16px;
  img {
    width: 56px;
    margin-top: 0.5rem;
  }
}
.error{
  color:lightsalmon;
  text-align: center;
  font-size: 20px;
  margin:100px 10px;
}
// .group {
//   margin: 10px;
//   background: #fd9126;
//   color: #fff;

//   .van-cell__title {
//     sapn {
//       font-size: 14px;
//       color: rgb(51, 51, 51);
//       font-weight: bold;
//     }
//   }
// }

// .cell {
//   .actionWrapper {
//     padding: 10px;

//     .van-button {
//       background: #fd9126;
//       color: #fff;
//     }
//   }

//   .active {
//     margin: 10px;

//     .border {
//       border-bottom: 1px solid rgb(231, 231, 231);
//     }
//     .gridmenu {
//       margin: 5px;
//       text-align: center;
//       img {
//         width: 40px;
//         margin-top: 0.5rem;
//       }
//     }
//     .titleInfo {
//       display: block;
//       font-size: 12px;
//       color: #666;
//       padding: 0 10px;

//       span {
//         text-align: center;
//         overflow: hidden;
//         word-break: break-word;
//         width: 100%;
//         -webkit-line-clamp: 3;
//       }
//     }
//   }
// }
</style>